
import { Link } from 'react-router-dom'

function navbar() {
  
    return (

        <>
            <nav className="navbar navbar-expand-md navbar-light full-nav">
                <div class="navbar-brand">
                    <a href='#'>maxcelant</a>
                </div>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="mainNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link to='/'>/home</Link>
                        </li>
                        <li className="nav-item">
                            <a href='/'>/stack</a>
                        </li>
                        <li className="nav-item">
                            <a href='/'>/contact</a>
                        </li>
                    </ul>
                </div>
            </nav>        
        </>
    )

}

export default navbar
